<section fxLayout="column" fxLayoutAlign="start center">
  <h2>Error</h2>
  <p>Something's not right! We're working to fix it.</p>
</section>
